import { render, staticRenderFns } from "./AdditionalFieldTd.vue?vue&type=template&id=451250f6"
import script from "./AdditionalFieldTd.vue?vue&type=script&lang=js"
export * from "./AdditionalFieldTd.vue?vue&type=script&lang=js"
import style0 from "./AdditionalFieldTd.vue?vue&type=style&index=0&id=451250f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports